const updateSnacks = async () => {
	return {};
};

export default updateSnacks;
